// 星宿数据加载工具
import constellationsData from '../data/constellations.json';

export interface Constellation {
  id: string;
  name: string;
  shortName: string;
  animal: string;
  element: string;
  description: string;
  personalityKeywords: string[];
  productId: string;
  color: string;
  origin_statue_feature: string;
  characteristics?: string;           // 属性特质文字介绍（新增字段，可选；为空时前端展示占位）
  guardianMessage: string;
  personalityGraph: string[];
  imageUrl: string | null;
  thumbnailUrl: string | null;
  sculptureImageUrl: string | null;
  sculptureThumbnailUrl: string | null;
}

// 获取所有星宿数据
export const getAllConstellations = (): Constellation[] => {
  return constellationsData as Constellation[];
};

// 根据ID获取单个星宿数据
export const getConstellationById = (id: string): Constellation | undefined => {
  return (constellationsData as Constellation[]).find(
    (constellation) => constellation.id === id
  );
};

// 根据名称获取单个星宿数据
export const getConstellationByName = (name: string): Constellation | undefined => {
  return (constellationsData as Constellation[]).find(
    (constellation) => constellation.name === name
  );
};

// 获取星宿的CSS颜色类名
export const getColorClass = (color: string): string => {
  const colorMap: Record<string, string> = {
    '#3B82F6': 'bg-blue-500',
    '#10B981': 'bg-emerald-500',
    '#8B5A2B': 'bg-brown-500',
    '#EF4444': 'bg-red-500',
    '#8B5CF6': 'bg-purple-500',
    '#F59E0B': 'bg-amber-500',
    '#06B6D4': 'bg-cyan-500',
  };
  return colorMap[color] || 'bg-ink-800';
};

// 获取元素对应的图标
export const getElementIcon = (element: string): string => {
  const iconMap: Record<string, string> = {
    '木': '🌳',
    '金': '⚔️',
    '土': '🏔️',
    '日': '☀️',
    '月': '🌙',
    '火': '🔥',
    '水': '💧',
  };
  return iconMap[element] || '✨';
};

// 获取动物形象对应的图标 emoji
// 覆盖二十八星宿全部本命禽（animal 字段为单字），未命中时兜底为通用爪印
export const getAnimalEmoji = (animal: string): string => {
  const animalIconMap: Record<string, string> = {
    '蛟': '🐉', '龙': '🐲', '貉': '🦝', '兔': '🐰', '狐': '🦊',
    '虎': '🐯', '豹': '🐆', '獬': '🦌', '牛': '🐂', '蝠': '🦇',
    '鼠': '🐭', '燕': '🕊️', '猪': '🐷', '貐': '🐗', '狼': '🐺',
    '狗': '🐶', '雉': '🦃', '鸡': '🐔', '乌': '🐦', '猴': '🐵',
    '猿': '🦍', '犴': '🐕', '羊': '🐑', '獐': '🦌', '马': '🐴',
    '鹿': '🦌', '蛇': '🐍', '蚓': '🪱',
  };
  return animalIconMap[animal] || '🐾';
};